import Vue from "vue";
import Vuex from "vuex";
import util from "@/util/index";
import router from "@/router";
import Public from "@/public";
import {
    login,
    getArea,
    getSite,
    addSite,
    addEquipment,
    addConnector,
    getConnector,
    getConnectorStatus,
    getConnact,
    addConnact,
    getEquipment,
    getOrder,
    getOrderDetail,
    getStationDetail,
    fetchStation,
    updatePrice,
    updateStation,
    updateConnact,
    uploadImg,
    updateEquipment,
    updateConnector,
    deletePile,
    deleteConnector,
    addCoupon,
    getCoupon,
    updateCoupon,
    deleteCoupon,
    getUserCoupon,
    resetConnector,
    settlementOrder,
    stopCharge,
    addActivity,
    getActivity,
    updateActivity,
    getOrderSummary,
    exportOrderExcel,
    getOrderQuerySum,
    getStationIdList,
    ICCard,
    generateRedeem,
	systemParams,
	getplatformList,
	couponQuerySum
} from "@/util/api";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: false, // 用户信息
        token: false,
		role: null, //权限  0:超级管理员；1:管理员
		platform_id: null,  //1:美森宝 2:维桩充电

        siteList: [], //下拉列表中的站点信息
        allArea: [], //所有的区域

        siteInfo: [], //站点信息
        siteIdList: [], //站点简易id列表
        connectorInfo: [], //充电抢信息
        connectorStatusInfo: [], //充电枪设备信息
        equipmentInfo: [], //充电桩信息
        contactInfo: [], //互联互通信息
        orderInfos: [], //订单信息
        couponInfos: [], //优惠券信息
        userCouponInfos: [], //用户持有优惠券信息
        activityInfos: [], //活动信息
        monthOrderSummary: [], //获取到 月 数据报表信息
        siteOrderSummary: [], //获取到 站点 数据报表信息
        dayOrderSummary: [], //获取 天 数据报表信息
        orderBlob: null, //获取到要导出的订单excel的blob
        orderQuerySum: null, //订单统计数据
		platformList: null,  //平台列表

        imgPath: null, //上传图片后获取到的图片地址
        orderDetail: null, //订单实时信息
        stationDetail: null, //站点详情
        resetConnectorResults: null,  //重置结果
        faultData: [{
                time: "2020/12/10",
                id: "2",
                site: "站点1",
                address: "江西省南昌市西湖区",
                people: "小明",
                phone: "123456778",
            },
            {
                time: "2020/12/10",
                id: "3",
                site: "站点1",
                address: "江西省南昌市西湖区",
                people: "小明",
                phone: "123456778",
            },
            {
                time: "2020/12/10",
                id: "4",
                site: "站点1",
                address: "江西省南昌市西湖区",
                people: "小明",
                phone: "123456778",
            },
        ], //告警信息
        toGunSiteId: null, //进入充电枪页面带入的站点id
        toPileId: null, //从充电桩页面进入充电枪页面带入的充电桩id
        isJump: false, //是否进行页面跳转
        gunData: null, //进入充电枪详情页面带入的充电枪信息
        orderData: null, //进入订单详情页带入的订单信息
        theme: {
            //主题
            topBarBgColor: "white", // 头部背景颜色
            projectNameColor: "#4dabf7", //名称颜色
            userNameColor: "#343a40", //用户名颜色
            titleBgColor: "#4dabf7", //标题背景颜色
            titleFontColor: "white", //标题字体颜色
            navigationDrawerBgColor: "#545c64", //导航背景颜色
            navigationDrawerFontColor: "#fff", //导航字体颜色
            activeDrawerFontColor: "#4dabf7", //导航点击后的字体颜色
            pageBgColor: "#e9ecef", //页面背景颜色
            pageFontColor: "#303133", //页面上的字体颜色
            elementBgColor: "#FFFFFF", //页面上的元素背景
            tableDark: false,
        },
        navigationMode: "vertical", //导航模式  vertical：左侧导航；horizontal：顶部导航
        showNavigation: false, //屏幕缩小时是否显示侧边导航栏
        showTip: false, // 消息气泡
        TipMsg: "", // 消息气泡内容
        TipType: 0, // 消息类型 0：正确 ; 1：错误; 3：警告
        ewmPath: require("../assets/ewm.jpg"), //二维码背景图,
		multiple: 7, //新建区数据翻7倍
    },
    getters: {},
    mutations: {
        USER_UPDATE(state, payload) {
			console.log(payload)
            state["user"] = payload;
            state["token"] = payload.token;
			state["platform_id"] = payload.platform_id;
			state["role"] = payload.type;
        },
        // 退出登录
        LOG_OUT(state) {
            state["user"] = false;
            state["token"] = false;
			state["platform_id"] = false;
			state["role"] = 3;
            localStorage.removeItem("user");
        },
        SHOW_TIP(state, payload) {
            state["showTip"] = true;
            if (payload[0] == "权限不够") {
                // payload[0] = "账号在其他设备登录";
                // this.commit("LOG_OUT");
            }
            state["TipMsg"] = payload[0];
            state["TipType"] = payload[1];
        },
        HIDE_TIP(state) {
            state["showTip"] = false;
            state["TipMsg"] = "";
            state["TipType"] = 0;
        },
        //设置主题
        SET_THEME(state, data) {
            state["theme"] = data;
            localStorage.setItem("theme", JSON.stringify(data));
        },
        //设置导航模式
        SET_NAVIGATION_MODE(state, data) {
            if (data != state.navigationMode) {
                state["navigationMode"] = data;
                if (data == "vertical") {
                    state["showNavigation"] = true;
                } else {
                    state["showNavigation"] = false;
                }
                localStorage.setItem("navigationMode", data);
            }
        },
        // 设置是否显示导航栏
        SET_SHOW_NAVIGATION(state, data) {
            state["showNavigation"] = data;
        },
        //设置是否跳转
        SET_ISJUMP(state, data) {
            state["isJump"] = data;
        },
        //设置充电桩id
        SET_PILE_ID(state, data) {
            state["toPileId"] = data;
        },
        //设置进入充电枪页面带入的站点id
        SET_GUN_SITE_ID(state, data) {
            state["toGunSiteId"] = data;
        },
        // 设置充电枪详情页面带入的充电枪信息
        SET_GUN_DETAIL(state, data) {
            state["gunData"] = data;
        },
        // 设置下拉列表中的站点信息
        SET_SITE_LIST(state, data) {
            state["siteList"] = data;
        },
        // 设置站点信息
        SET_SITE_INFO(state, data) {
            state["siteInfo"] = data;
        },
        // 设置充电枪信息
        SET_CONNECTOR_INFO(state, data) {
            state["connectorInfo"] = data;
        },
        // 设置充电枪状态信息
        SET_CONNECTOR_STATUS(state, data) {
            state["connectorStatusInfo"] = data;
        },
        // 设置充电桩信息
        SET_EQUIPMENT_INFO(state, data) {
            state["equipmentInfo"] = data;
        },
        // 设置区域信息
        SET_AREA(state, data) {
            state["allArea"] = data;
        },
        // 设置互联互通信息
        SET_CONNACT(state, data) {
            state["contactInfo"] = data;
        },
        // 设置订单信息
        SET_ORDER(state, data) {
            state["orderInfos"] = data;
        },
        // 设置订单详情
        SET_ORDER_DETAIL(state, data) {
            state["orderDetail"] = data;
        },
        // 设置进入订单详情页带入的订单信息
        SET_ORDER_INFO(state, data) {
            state["orderData"] = data;
        },
        // 设置站点详情
        SET_STATION_DETAIL(state, data) {
            state["stationDetail"] = data;
        },
        // 设置传图片后获取到的图片地址
        SET_IMG(state, data) {
            state["imgPath"] = data;
        },
        // 设置优惠券信息
        SET_COUPON(state, data) {
            state["couponInfos"] = data;
        },
        //设置用户持有优惠券信息
        SET_USER_COUPONS(state, data) {
            state["userCouponInfos"] = data;
        },
        //设置活动信息
        SET_ACTIVITIES(state, data) {
            state["activityInfos"] = data;
        },
        //设置 月 数据报表
        SET_MONTH_ORDER_SUMMARY(state, data) {
            state["monthOrderSummary"] = data;
        },
        //设置 站点 数据报表
        SET_SITE_ORDER_SUMMARY(state, data) {
            state["siteOrderSummary"] = data;
        },
        //设置 天 数据报表
        SET_DAY_ORDER_SUMMARY(state, data) {
            state["dayOrderSummary"] = data;
        },
        //设置导出订单数据blob信息
        SET_ORDER_EXCEL_BLOB(state, data) {
            state["orderBlob"] = data;
        },
        //设置订单数据统计信息
        SET_ORDER_QUERY_SUM(state, data) {
            state["orderQuerySum"] = data;
        },
        //设置站点id信息
        SET_SITE_ID_LIST(state, data) {
            state["siteIdList"] = data;
        },
        //设置重置结果
        SET_RESET_CONNECTORS(state, data) {
            state["resetConnectorResults"] = data;
        },
		// 设置平台列表
		SET_PLATFORM_LIST(state, data) {
			state["platformList"] = data;
		}
    },
    actions: {
        /**
    * 登录
    * @param {*} content
    * @param {*} params : {
    postData 数据,page 页面,callback1 关闭动画，callback2存储密码
    }
    */
        async login(content, params) {
            const result = await login(params.postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("USER_UPDATE", result.data.data);
                    let data = JSON.stringify(result.data.data);
                    localStorage.setItem("user", data);
                    util.ShowTip("登录成功", 1);
                    params.callback2();
                }
                if (result.data.result === "Fail") {
                    localStorage.removeItem("account");
                }
            } catch (error) {
                // console.log(error);
            }
            params.callback1();
        },
        // 获取平台列表
		async getplatformList(content, postData) {
			if(this.state.role != 0) {
				return;
			}
			const result = await getplatformList(postData);
			try{
				if (result.data.result === "OK") {
				    content.commit("SET_PLATFORM_LIST", result.data.data);
				} else {
				    util.ShowTip("获取平台列表失败：" + data.msg, 2);
				}
			}catch(e){
				//TODO handle the exception
			}
		},
		//获取区域
        async getArea(content, postData) {
            const result = await getArea(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_AREA", result.data.data);
                } else {
                    util.ShowTip("获取区域失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取某个区域下的所有站点
        async getSite(content, postData) {
            const result = await getSite(postData);
            try {
                if (result.data.result === "OK") {
					let data = result.data.data;
					for(let i = 0;i<data.length;i++) {
						data[i].name = Public.setStationName(content.state.user,data[i].name);
					}
                    content.commit("SET_SITE_INFO", data);
                } else {
                    util.ShowTip("获取站点失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取某个站点下的充电枪信息
        async getConnector(content, postData) {
            const result = await getConnector(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_CONNECTOR_INFO", result.data.data);
                } else {
                    util.ShowTip("获取充电枪信息失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取某个站点下的充电枪的状态
        async getConnectorStatus(content, postData) {
            const result = await getConnectorStatus(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_CONNECTOR_STATUS", result.data.data);
                } else {
                    util.ShowTip("获取充电枪状态失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取互联互通信息
        async getConnact(content, postData) {
			if(this.state.role != 0) {
				return;
			}
            const result = await getConnact(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_CONNACT", result.data.data);
                } else {
                    util.ShowTip("获取互联互通信息失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取某个站点下的充电桩
        async getEquipment(content, postData) {
            const result = await getEquipment(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_EQUIPMENT_INFO", result.data.data);
                } else {
                    util.ShowTip("获取信息失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取订单
        async getOrder(content, params) {
            const result = await getOrder(params.postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_ORDER", result.data.data);
                } else {
                    util.ShowTip("获取订单失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
                // util.ShowTip("获取订单信息出现未知错误，请尝试刷新重试", 2);
            }
            params.callback();
        },
        //获取订单实时信息
        async getOrderDetail(content, postData) {
            const result = await getOrderDetail(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_ORDER_DETAIL", result.data.data);
                } else {
                    util.ShowTip("获取订单实时信息失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //获取站点详情
        async getStationDetail(content, postData) {
            const result = await getStationDetail(postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_STATION_DETAIL", result.data.data);
                } else {
                    util.ShowTip("获取站点详情失败：" + data.msg, 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //拉取站点
        async fetchStation(_content, params) {
            const result = await fetchStation(params.data);
            try {
                if (result.data.result === "OK") {
                    util.ShowTip("拉取站点成功", 1);
                } else {
                    util.ShowTip("拉取站点失败", 2);
                }
            } catch (error) {
                // console.log(error);
            }
            params.callback();
        },
        //更新价格
        async updatePrice(_content, postData) {
            const result = await updatePrice(postData);
            try {
                if (result.data.result === "OK") {
                    util.ShowTip("更新价格成功", 1);
                } else {
                    util.ShowTip("更新价格失败", 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        //上传图片
        async uploadImg(content, postData) {
            const result = await uploadImg(postData);
            try {
                if (result.data.result === "OK") {
                    util.ShowTip("上传图片成功", 1);
                    content.commit("SET_IMG", result.data.data);
                } else {
                    util.ShowTip("上传图片失败", 2);
                }
            } catch (error) {
                // console.log(error);
            }
        },
        /**
             * 添加站点
             * @param {*} _content
             * @param {*} params: {
                    postData 参数,
                    page 页面this,
                    callback 回调函数
                }
             */
        async addSite(_content, params) {
            const result = await addSite(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
                params.callback();
            } else {
                util.ShowTip("添加失败：", 2);
            }
        },
        //修改站点信息
        async updateStation(_content, params) {
            const result = await updateStation(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败：" + data.msg, 2);
            }
        },
        /**
             * 添加互联互通
             * @param {*} _content
             * @param {*} params: {
                    postData 参数,
                    page 页面this,
                    callback 回调函数
                }
             */
        async addConnact(_content, params) {
			if(this.state.role != 0) {
				util.ShowTip("权限不足", 3);
				return;
			}
            const result = await addConnact(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
                params.callback();
            } else {
                util.ShowTip("添加失败", 2);
            }
        },
        //修改互联互通信息
        async updateConnact(_content, params) {
			if(this.state.role != 0) {
				util.ShowTip("权限不足", 3);
				return;
			}
            const result = await updateConnact(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败", 2);
            }
        },
        /**
             * 添加充电桩
             * @param {*} _content
             * @param {*} params: {
                    postData 参数,
                    page 页面this,
                    callback 回调函数
                }
             */
        async addEquipment(_content, params) {
            const result = await addEquipment(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
                params.callback();
            } else {
                util.ShowTip("添加失败", 2);
            }
        },
        /*批量添加充电桩*/
        async addMoreEquipment(_content, params) {
            const result = await addEquipment(params.postData);
            if (result.data.result != "OK" || result.statusText != "OK") {
                params.callbackError(params);
            }
            params.callbackOK(params.i);
        },
        //修改充电桩信息
        async updateEquipment(_content, params) {
            const result = await updateEquipment(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败", 2);
            }
        },
        /**
             * 添加充电枪
             * @param {*} _content
             * @param {*} params: {
                postData 参数,
                page 页面this,
                callback 回调
                }
             */
        async addConnector(_content, params) {
            const result = await addConnector(params.postData);
            if (params.isMore) {
                return;
            }
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
            } else {
                util.ShowTip("添加失败", 2);
            }
            params.callback();
        },
        //修改充电枪信息
        async updateConnector(_content, params) {
            const result = await updateConnector(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败", 2);
            }
        },
        // 删除充电桩
        async deletePile(_content, params) {
            const result = await deletePile(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("删除成功", 1);
                params.callback();
            } else {
                util.ShowTip("删除失败", 2);
            }
        },
        //删除充电枪
        async deleteConnector(_content, params) {
            const result = await deleteConnector(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("删除成功", 1);
                params.callback();
            } else {
                util.ShowTip("删除失败", 2);
            }
        },
        //添加优惠券
        async addCoupon(_content, params) {
            const result = await addCoupon(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
                params.callback();
            } else {
                util.ShowTip("添加失败：" + data.msg, 2);
            }
        },
        // 获取优惠券信息
        async getCoupon(content, params) {
            const result = await getCoupon(params.postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_COUPON", result.data.data);
                } else {
                    util.ShowTip(data.msg, 2);
                }
            } catch (error) {
                console.log(error);
            }
            params.callback();
        },
        //修改优惠券信息
        async updateCoupon(_content, params) {
            const result = await updateCoupon(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败：" + data.msg, 2);
            }
        },
		// 统计所有优惠券
		async couponQuerySum(_content, params) {
			const result = await couponQuerySum(params.postData);
			if (result.data.result === "OK") {
			    params.callbackOk(result.data);
			} else {
			    util.ShowTip("获取优惠卷统计信息失败", 2);
			}
		},
        // 删除优惠券
        async deleteCoupon(_content, params) {
            const result = await deleteCoupon(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("删除成功", 1);
                params.callback();
            } else {
                util.ShowTip("删除失败", 2);
            }
        },
        //用户所持有的优惠券列表
        async getUserCoupon(content, params) {
            const result = await getUserCoupon(params.postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_USER_COUPONS", result.data.data);
                    if (params.isSearch) {
                        params.callbackOk();
                    }
                } else {
                    util.ShowTip(data.msg, 2);
                    if (params.isSearch) {
                        params.callbackError();
                    }
                }
            } catch (error) {
                console.log(error);
            }
            params.callback();
        },
        // 重置充电枪状态
        async resetConnector(content, params) {
            const result = await resetConnector(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("重置成功", 1);
                params.callback();
            } else {
                util.ShowTip("重置失败", 2);
            }
        },
        //批量重置充电枪
        async resetConnectors(content, postData) {
            const result = await resetConnector(postData);
            content.commit("SET_RESET_CONNECTORS", result.data);
        },
        //手动结算订单
        async settlementOrder(content, params) {
            const result = await settlementOrder(params.postData);
            console.log(result);
            if (result.data.result === "OK") {
                util.ShowTip("操作成功", 1);
            } else {
                util.ShowTip("操作失败：" + data.msg, 2);
            }
            params.callback();
        },
        /*停止充电*/
        async stopCharge(content, params) {
            const result = await stopCharge(params.postData);
        },
        //添加活动
        async addActivity(_content, params) {
            const result = await addActivity(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("添加成功", 1);
                params.callback();
            } else {
                util.ShowTip("添加失败：" + data.msg, 2);
            }
        },
        //获取活动列表
        async getActivity(content, params) {
            const result = await getActivity(params.postData);
            try {
                if (result.data.result === "OK") {
                    content.commit("SET_ACTIVITIES", result.data.data);
                    // params.callbackOk();
                } else {
                    util.ShowTip(data.msg, 2);
                    // params.callbackError();
                }
            } catch (error) {
                console.log(error);
            }
            params.callback();
        },
        //修改活动信息
        async updateActivity(_content, params) {
            const result = await updateActivity(params.postData);
            if (result.data.result === "OK") {
                util.ShowTip("修改成功", 1);
                params.callback();
            } else {
                util.ShowTip("修改失败：" + data.msg, 2);
            }
        },
        //获取订单数据报表
        async getOrderSummary(content, params) {
            const result = await getOrderSummary(params.postData);
			try{
				if (result.data.result === "OK") {
				    if (params.postData.sum_type == 0) {
				        content.commit("SET_DAY_ORDER_SUMMARY", result.data.data);
				    } else if (params.postData.sum_type == 1) {
				        content.commit("SET_MONTH_ORDER_SUMMARY", result.data.data);
				    } else if (params.postData.sum_type == 2) {
						let data = result.data.data;
						for(let i = 0;i<data.length;i++) {
							data[i].name = Public.setStationName(content.state.user,data[i].name);
						}
				        content.commit("SET_SITE_ORDER_SUMMARY", data);
				    }
				} else {
				    util.ShowTip(data.msg, 2);
				}
				params.callback();
			}catch(e){
				console.log(e)
				// params.callbackErr();
				//TODO handle the exception
			}
            
        },
        //导出订单excel
        async exportOrderExcel(content, params) {
            const result = await exportOrderExcel(params.postData);
            if (result.status === 200) {
                content.commit("SET_ORDER_EXCEL_BLOB", result.data);
            } else {
                util.ShowTip("导出失败", 2);
            }
            params.callback();
        },
        //订单统计
        async getOrderQuerySum(content, params) {
            const result = await getOrderQuerySum(params.postData);
            if (result.data.result === "OK") {
                content.commit("SET_ORDER_QUERY_SUM", result.data.data);
            } else {
                util.ShowTip(data.msg, 2);
            }
        },
        //获取简易站点id列表
        async getStationIdList(content, postData) {
            const result = await getStationIdList(postData);
            if (result.data.result === "OK") {
                content.commit("SET_SITE_ID_LIST", result.data.data);
            } else {
                util.ShowTip(data.msg, 2);
            }
        },
        //添加IC卡
        async addICCard(content, params) {
            const result = await ICCard.addICCard(params.postData);
			if (result.data.result === "OK") {
				util.ShowTip("添加成功", 1);
			    params.callbackOk();
			} else {
			    util.ShowTip(data.msg, 2);
			}
        },
        //获取IC卡列表
        async getICCardList(content, params) {
            const result = await ICCard.getICCardList(params.postData);
			try{
				if (result.data.result === "OK") {
				    params.callbackOk(result.data.data);
				} else {
				    util.ShowTip(data.msg, 2);
				}
			}catch(e){
				//TODO handle the exception
			}
			params.callback();
        },
        //生成优惠券兑换码
        async generateRedeem(content, params) {
            const result = await generateRedeem(params.postData);
            // console.log(result);
            if (result.status === 200) {
                params.callbackOk(result.data);
            } else {
                util.ShowTip("生成失败", 2);
            }
            params.callback();
        },
		//添加系统参数
		async addSystem(content, params) {
            const result = await systemParams.addSystem(params.postData);
            if (result.status === 200) {
				util.ShowTip("添加成功", 1);
                params.callbackOk();
            } else {
                util.ShowTip("添加失败", 2);
            }
		},
		//修改系统参数
		async updateSystem(content, params) {
		    const result = await systemParams.updateSystem(params.postData);
		    if (result.status === 200) {
				util.ShowTip("修改成功", 1);
		        params.callbackOk();
		    } else {
		        util.ShowTip("修改失败", 2);
		    }
		},
		//获取系统参数列表
		async getSystemList(content, params) {
            const result = await systemParams.getSystemList(params.postData);
            if (result.status === 200) {
                params.callbackOk(result.data.data);
            } else {
                util.ShowTip("获取失败", 2);
				params.callbackErr();
            }
        },
    },
    modules: {},
});